import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import authProvider from './authProvider';
import { AUTH_LOGIN } from 'react-admin';
import { REDIRECT_URL } from './Constants/index';

const tokenStart = 'token=';
let url = document.location.search;
let token = url.substring(url.indexOf(tokenStart) + tokenStart.length, url.length);

if (token && token.length > 0) {
    localStorage.setItem('auth-token', token);
    window.history.replaceState({}, document.title, "/");
    checkCordova();
}
else if (localStorage.getItem('auth-token') !== null && localStorage.getItem('auth-token') !== "undefined") {
    checkCordova();
}
else {
    alert('You need an authentication token to see this page');
    document.location.href = REDIRECT_URL;
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

function checkCordova() {
    // The usingCordova function returns true if cordova is in the window
    if (window.usingCordova) {
        // Init app on device ready
        document.addEventListener("deviceready", () => {
            initApp();
        }, false);
    } else {
        // Init app immediately
        initApp();
    }
}

async function initApp() {
    authProvider(AUTH_LOGIN).then(
        result => {
            const appRoot = document.getElementById('root')
            document.getElementsByTagName('body')[0].setAttribute('translate', "no")
            ReactDOM.render(<App />, appRoot)
        },
        error => {
            alert(error);
            document.location.href = REDIRECT_URL;
        }
    );
}